import request from '@/utils/request'
const purchaseApi = process.env.VUE_APP_PURCHASE_API

import store from '@/store'
import { workbenchServiceDict } from '@/dictionary/system'
import { addQueryToUrl } from '@/utils/utils'

function getPlatformAlias() {
  return workbenchServiceDict.array.find(
    item => item.value === store.state.router.currentWorkbench
  ).platformAlias
}

// 预先生成标书
export function preCreateKpbBiddingFileApi() {
  return request({
    url: purchaseApi + '/workbench/purchaser/kpb/bidding-files/advance',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 保存为草稿
export function saveKpbBiddingFileApi(fileId, data) {
  return request({
    url: purchaseApi + `/workbench/purchaser/kpb/bidding-files/${fileId}/draft`,
    method: 'put',
    data
  })
}

// 更新并发布电子标书
export function updateKpbBiddingFileApi(fileId, data) {
  return request({
    url: purchaseApi + `/workbench/purchaser/kpb/bidding-files/${fileId}`,
    method: 'put',
    data
  })
}

// 查询电子标书详情
export function getKpbBiddingFileApi(fileId) {
  return request({
    url:
      purchaseApi + `/workbench/purchaser/kpb/bidding-files/${fileId}/detail`,
    method: 'get'
  })
}

// 查询电子标书
export function getKpbBiddingFileInfoApi(fileId) {
  return request({
    url: purchaseApi + `/workbench/purchaser/kpb/bidding-files/${fileId}`,
    method: 'get'
  })
}

/**
 * 灰度发布配置获取-开评标配置
 */
export function grayscaleConfigApi() {
  return request({
    url: purchaseApi + '/workbench/grayscale/kpb',
    method: 'get'
  })
}

// 评审结束后，可重启评审
export function restartKpbProjectReviewApi(projectId, processId) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/review-restart`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 下载电子标书附件
export function downloadKpbProjectBiddingFileApi(params) {
  const fileId = params.fileId
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/kpb/bidding-files/${fileId}/download-bidding-file`,
    method: 'get',
    params
  })
}

// 预览电子标书附件
export function previewKpbProjectBiddingFileApi(params) {
  const fileId = params.fileId
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/kpb/bidding-files/${fileId}/preview-bidding-file`,
    method: 'get',
    params
  })
}

/**
 * 新增开评标项目
 * @param {Object} data 请求数据
 * @returns {Promise<void>|*}
 */
export function addOpenBiddingProjectApi(data) {
  return request({
    url: purchaseApi + '/workbench/purchaser/kpb/projects',
    method: 'post',
    data
  })
}

/**
 * 更新开评标项目
 * @param {number} projectId
 * @param {Object} data
 * @returns {Promise<void>|*}
 */
export function updateOpenBiddingProjectApi(projectId, data) {
  return request({
    url: purchaseApi + `/workbench/purchaser/kpb/projects/${projectId}`,
    method: 'put',
    data
  })
}

/**
 * 查询开评标项目详情
 * @param {number} projectId
 * @returns {Promise<void>|*}
 */
export function getOpenBiddingProjectApi(projectId) {
  return request({
    url: purchaseApi + `/workbench/purchaser/kpb/projects/${projectId}/detail`,
    method: 'get'
  })
}

/**
 * 同步抽取结果并组建专家
 * @param {number} projectId 项目id
 * @returns {Promise<void>|*}
 */
export function syncExpertExtractionApi(projectId) {
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/kpb/projects/${projectId}/reviewers/formation-extract`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 从历史项目中复制专家
 * @param {number} projectId 项目id
 * @param {number} oldProjectId 历史项目id
 * @returns {Promise<void>|*}
 */
export function copyExpertFromHistoryApi(projectId, oldProjectId) {
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/kpb/projects/${projectId}/reviewers/formation-old-projects/${oldProjectId}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 分页查询开评标项目
 * @param {Object} params 请求参数
 */
export function getKpbProjectListApi(params) {
  return request({
    url: purchaseApi + '/workbench/purchaser/page/kpb-projects',
    method: 'get',
    params
  })
}

/**
 * 分页查询评审专家列表
 * @param {number} projectId 项目id
 * @param {Object} data
 * @returns {Promise<void>|*}
 */
export function getBidExpertListApi(projectId, params) {
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/kpb/projects/${projectId}/reviewers/page`,
    method: 'get',
    params
  })
}

/**
 * 移除评审专家
 * @param {number} projectId 项目id
 * @param {number} reviewerId 评审专家id
 * @returns {Promise<void>|*}
 */
export function removeExpertApi(projectId, reviewerId) {
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/kpb/projects/${projectId}/reviewers/${reviewerId}/remove`,
    method: 'put'
  })
}

/**
 * 撤销移除评审专家
 * @param {number} projectId 项目id
 * @param {number} reviewerId 评审专家id
 * @returns {Promise<void>|*}
 */
export function revokeRemoveExpertApi(projectId, reviewerId) {
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/kpb/projects/${projectId}/reviewers/${reviewerId}/remove-cancel`,
    method: 'put'
  })
}

// 查询评审专家信息
export function getExpertInfoApi(projectId, reviewerId) {
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/kpb/projects/${projectId}/reviewers/${reviewerId}`,
    method: 'get'
  })
}

// 评委重置密码
export function resetExpertPasswordApi(projectId, reviewerId, data) {
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/kpb/projects/${projectId}/reviewers/${reviewerId}/reset-password`,
    method: 'put',
    data
  })
}

// 发起评标
export function startReviewApi(projectId) {
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/kpb/projects/${projectId}/initiate-review`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 综合评分排序表
export function getRatingRankApi(projectId) {
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/kpb/projects/${projectId}/rating-rank`,
    method: 'get'
  })
}

/**
 * 导入评审办法
 */
export function importReviewWaysExcelApi(data) {
  return request(
    {
      url:
        purchaseApi +
        `/workbench/purchaser/kpb/bidding-files/review-ways/import`,
      method: 'post',
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    },
    true,
    true
  )
}

/**
 * 导出评审办法
 */
export function exportReviewWaysExcelApi(params) {
  window.open(
    addQueryToUrl(
      `${purchaseApi}/workbench/purchaser/kpb/bidding-files/review-ways/export`,
      { fileId: params.fileId, identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

// 手动新增专家到评委列表
export function manualAddExpertToReviewerApi(projectId, data) {
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/kpb/projects/${projectId}/reviewers/manual-add`,
    method: 'post',
    data
  })
}

// 一键重置密码，并返回专家密码
export function resetAllExpertPasswordApi(projectId) {
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/kpb/projects/${projectId}/reviewers/reset-password`,
    method: 'put',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 批量查询评审专家列表
export function getExpertListByBidApi(params) {
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/kpb/projects/bidding-orders/reviewers`,
    method: 'get',
    params
  })
}
